// Tải một danh sách GitHub nhiều trang (per_page=100) theo ĐỢT SONG SONG thay vì nối đuôi nhau.
//
// Vì sao: GitHub không cho biết trước có bao nhiêu trang (proxy cũng không chuyển tiếp tiêu đề Link tới giao diện),
// nên cách cũ — xin trang 2 sau khi trang 1 về, rồi trang 3 sau khi trang 2 về… — tốn MỘT vòng mạng cho mỗi trang.
// Đo thật 30/09 (399 việc mở = 4 trang): trang 2→5 về lúc 638 · 725 · 760 · 808 ms, trong khi trang 1 về lúc 381 ms.
// Ở đây đợt đầu gọi luôn `goi_y` trang cùng lúc (đoán từ lần tải trước), chỉ xin thêm đợt nữa khi trang cuối của đợt
// còn ĐẦY. Trang ngoài cuối GitHub trả mảng rỗng (không lỗi) nên đoán dư chỉ tốn vài lượt gọi rẻ.

export interface KetQuaPhanTrang<T> {
  ds: T[];
  // Số trang THỰC SỰ cần: tính tới trang ngắn đầu tiên (trang rỗng cuối cũng tính — nó cho biết hết). Đoán dư không tính.
  so_trang: number;
  // true = chạm trần `toi_da` mà trang cuối vẫn đầy → còn mục chưa tải về. Người gọi phải báo, đừng nuốt im.
  bi_cat: boolean;
}

export interface TuyChonPhanTrang<T> {
  // Số mục đầy một trang (= per_page). Trang ngắn hơn số này là trang cuối thật.
  co_trang?: number;
  // Số trang của đợt đầu (mặc định = `dot`). Truyền số trang đã cần ở lần tải trước để khỏi đoán thiếu.
  goi_y?: number;
  // Số trang mỗi đợt tiếp theo.
  dot?: number;
  // Trần an toàn (số trang) — chặn vòng lặp vô tận nếu API trả trang đầy mãi.
  toi_da?: number;
  // Khử trùng: danh sách đổi giữa các lượt gọi (việc mới chen lên đầu) làm một mục nằm ở cuối trang n và đầu trang n+1.
  khoa?: (x: T) => string | number;
}

export async function napPhanTrang<T>(
  lay: (trang: number) => Promise<T[]>,
  tc: TuyChonPhanTrang<T> = {},
): Promise<KetQuaPhanTrang<T>> {
  const co_trang = tc.co_trang ?? 100;
  const dot = Math.max(1, Math.floor(tc.dot ?? 4));
  const toi_da = Math.max(1, Math.floor(tc.toi_da ?? 30));
  const cac_trang: T[][] = [];
  let tiep = 1;
  let co_het = false;
  // Gợi ý đến từ localStorage (sửa tay / hỏng được) → không tin quá 8 trang cho đợt đầu, khỏi bắn cả chục lượt một lúc.
  let kich = Math.min(Math.max(dot, 8), Math.max(1, Math.floor(tc.goi_y ?? dot)));
  while (!co_het && tiep <= toi_da) {
    const cuoi = Math.min(tiep + kich - 1, toi_da);
    const so: number[] = [];
    for (let t = tiep; t <= cuoi; t++) so.push(t);
    cac_trang.push(...(await Promise.all(so.map(lay))));
    // Trang ngắn đầu tiên là trang cuối thật; trang sau nó trong đợt (nếu có) rỗng, hoặc do dữ liệu vừa đổi — vẫn gộp.
    co_het = cac_trang.some((t) => t.length < co_trang);
    tiep = cuoi + 1;
    kich = dot;
  }
  const i_ngan = cac_trang.findIndex((t) => t.length < co_trang);
  const gop = cac_trang.flat();
  let ds = gop;
  if (tc.khoa) {
    const da = new Set<string | number>();
    ds = gop.filter((x) => {
      const k = tc.khoa!(x);
      if (da.has(k)) return false;
      da.add(k);
      return true;
    });
  }
  return { ds, so_trang: i_ngan >= 0 ? i_ngan + 1 : cac_trang.length, bi_cat: !co_het };
}

// Nhớ số trang đã cần ở lần tải trước (theo tên danh sách) để đợt đầu gọi đúng chừng đó trang: máy đã dùng app rồi thì
// tải lạnh cũng chỉ một vòng mạng. Lưu ở localStorage (chỉ là một con số, không có dữ liệu việc); bị chặn lưu trữ →
// dùng `mac_dinh`, chậm hơn một chút chứ không sai.
const KHOA_LUU = 'vtask:so-trang';
const trong_bo_nho = new Map<string, number>();

// Kiểu tối thiểu thay cho `Storage` (tsconfig.test.json không nạp thư viện DOM). Không có / bị chặn → null.
interface KhoLuu { getItem(k: string): string | null; setItem(k: string, v: string): void }
function khoLuu(): KhoLuu | null {
  try { return (globalThis as { localStorage?: KhoLuu }).localStorage ?? null; } catch { return null; }
}

function docLuu(): Record<string, number> {
  try {
    const j = JSON.parse(khoLuu()?.getItem(KHOA_LUU) || '{}');
    return j && typeof j === 'object' ? j : {};
  } catch { return {}; }
}

export function goiYSoTrang(ten: string, mac_dinh: number): number {
  const v = trong_bo_nho.get(ten) ?? docLuu()[ten];
  return typeof v === 'number' && Number.isInteger(v) && v >= 1 && v <= 100 ? v : mac_dinh;
}

export function nhoSoTrang(ten: string, so: number) {
  if (!Number.isInteger(so) || so < 1 || so > 100 || trong_bo_nho.get(ten) === so) return;
  trong_bo_nho.set(ten, so);
  try { khoLuu()?.setItem(KHOA_LUU, JSON.stringify({ ...docLuu(), [ten]: so })); } catch { /* chặn lưu trữ → bỏ */ }
}
